import { ApplicationEnum } from "~/@types/enums";

const routeToTheme: Record<string, ApplicationEnum> = {
	availability: ApplicationEnum.AVAILABILITY,
	benchmark: ApplicationEnum.BENCHMARK,
	count: ApplicationEnum.COUNT,
	engage: ApplicationEnum.ENGAGE,
	events: ApplicationEnum.EVENTS,
	forecast: ApplicationEnum.FORECAST,
	fulfill: ApplicationEnum.FULFILL,
	intelligence: ApplicationEnum.INTELLIGENCE,
	material: ApplicationEnum.MATERIAL,
	portal: ApplicationEnum.PORTAL,
	produce: ApplicationEnum.PRODUCE,
	reports: ApplicationEnum.REPORTS,
	restock: ApplicationEnum.RESTOCK,
	verify: ApplicationEnum.VERIFY
};

const resolveThemeModule = (pathname: string): ApplicationEnum => {
	const themedSegment = pathname
		.split("/")
		.find((segment) => Object.prototype.hasOwnProperty.call(routeToTheme, segment));
	return themedSegment ? routeToTheme[themedSegment] : ApplicationEnum.WORKSUITE;
};

export default resolveThemeModule;
